<template>
  <div class="wrap orderFail">
    <div class="header">
      <NavBar
        title="Payment Completed"
        left-arrow
        @click-left="$router.push('/productList?'+ getStore('shareHttp'))"
        class="no_bg"
      >
      </NavBar>
    </div>
    <div class="main">
      <div class="Box">
        <div class="imgBox">
          <img src="../../../public/img/orderSuccess.png" alt="" />
        </div>
        <div class="text">
          Thank you for your payment. Your transaction has been completed, and a
          receipt for your purchase has been emailed to you. Log into your <span class="Paypal">PayPal</span>
          account to view transaction details
        </div>
      </div>
      <div class="Separate"></div>
      <Cell title="Order number">
        <template #right-icon>
          <!-- <span class="custom-title">{{$route.query.orderId}}</span> -->
          <span class="custom-title">{{$route.query.orderSn}}</span>
        </template>
      </Cell>
      <Cell title="Date">
        <template #right-icon>
          <span class="custom-title">{{time}}</span>
        </template>
      </Cell>
      <Cell title="Total">
        <template #right-icon>
          <span class="custom-title">${{$route.query.paymentMoney}}</span>
        </template>
      </Cell>
      <Cell title="Payment method">
        <template #title>
          <span class="pdr5">Payment method</span>
          <!-- <Tag plain type="danger">paypay支付</Tag> -->
        </template>
        <template #right-icon>
          <span class="custom-title pdr5">PayPal</span>
          <!-- <van-icon name="search" class="search-icon" /> -->
        </template>
      </Cell>
    </div>
  </div>
</template>
<script>
import moment from 'moment'
import { toTime } from "../../utils/common";
import { removeStore, getStore, setStore } from "../../utils/storage";
export default {
  data() {
    return {
      time:''
    }
  },
  methods:{
    toTime,
    getStore
  },
  mounted(){
    // console.log(this.$route.query)
    this.time = moment(new Date(this.$route.query.payTime)).format('MM/DD/YYYY HH:MM:SS')

  }
}
</script>
<style lang="less" scoped>
.orderFail {
  .Box {    
    padding: 0 10px;
    background: #fff;
    text-align:center;
    .text {
      line-height: 18px;
      color: #090A0E;
      font-size: 13px;
      margin: 20px 0;
      text-align: left;
      .Paypal{
        color: #16C7CE;
      }
    }
    .imgBox {
      margin-top: 30px;
      img {
        width: 78px;
        height: 78px;
      }
    }
    .line {
      margin: 20px 0;
      border-bottom: 1px #ccc solid;
    }
  }
  .custom-title{
      font-size: 15px;
      color:#9BA1AA
    }
}
</style>
<style>
.orderFail .van-button--primary {
  border: 0.028571rem solid #16c7ce;
}
.orderFail .van-cell {
  font-size: 12px;
  text-align: left;
}
.orderFail .van-checkbox__icon .van-icon {
  font-size: 12px;
}
</style>
